import { getImageUrlFromName } from '../../../util'
const LineSeparatorLayout = ({ layout, value }) => {
  let imageUrl = getImageUrlFromName(layout.icon_name)
  return (
    <div
      style={{
        padding: '16px 20px 32px 20px',
        background: layout.color ? `#${layout.color}` : '',
      }}
    >
      <div>
        <img src={imageUrl} alt="" />
      </div>
      <div
        style={{
          marginTop: '10px',
          marginBottom: '10px',
          textAlign: 'left',
          listStyle: 'none',
          color: 'var(--gray100)',
        }}
      >
        <p className="title1">{layout.display_name}</p>
      </div>
    </div>
  )
}
export default LineSeparatorLayout
